export const LANGUAGE_KEY = 'WEHRLE:Language';
